import React, { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";

import LayoutOnboarding from "~/components/Layout";
import Button from "components/Button";
import Spinner from "components/Spinner";
import Camera from "components/NewCamera";
import Loading from "components/Loader";

import * as St from "./styles";
import OneButtonPopup from "~/components/Modals/OneButtonPopup";
import TwoButtonPopup from "~/components/Modals/TwoButtonPopup";
import Endpoints from "~/services/endpoints";
import useApi, { ApiMethod } from "~/hooks/useApi";
import themes from "~/themes";
import assets from "~/assets";
import { useContext } from "react";
import { GlobalContext } from "~/contexts/GlobalState";
import Loader from "components/Loader";

const IMAGE_TYPES = {
  RESIDENTIAL: "ENDERECO",
  INCOME: "RENDA",
};

const SubmitDocuments = () => {
  const [cam1DocumentsIsOpen, setCam1DocumentsIsOpen] = useState(false);
  const [cam2DocumentsIsOpen, setCam2DocumentsIsOpen] = useState(false);
  const [documentsPicture1, setDocumentsPicture1] = useState(null);
  const [documentsPicture2, setDocumentsPicture2] = useState(null);
  const [imageIsLoading, setImageIsLoading] = useState(false);
  const [auxImage, setAuxImage] = useState("");
  const [errorUploadDocumentResidential, setErrorUploadDocumentResidential] =
    useState(false);
  const [errorUploadDocumentIncome, setErrorUploadDocumentIncome] =
    useState(false);
  const [errorPopUpUpload, setErrorPopUpUpload] = useState(false);
  const [lastPictureUploaded, setLastPictureUploaded] = useState();
  const [success, setSuccess] = useState();
  const [dialogOpen, setDialogOpen] = useState(false);
  const { lending } = useContext(GlobalContext);

  const toggleCameraDocuments = (index) => {
    if (index === 1) {
      setCam1DocumentsIsOpen(true);
    } else {
      setCam2DocumentsIsOpen(true);
    }
  };

  const history = useHistory();

  const { state } = useLocation();

  const PostSendDocuments = useApi(
    Endpoints.lendings.postSendProposalEasyCredito.replace(
      "ID_LOAN",
      lending?.idSimulacao
    ),
    ApiMethod.POST
  );

  const handleUploadPicture = async (image, type) => {
    setImageIsLoading(type);
    setAuxImage(image);

    try {
      switch (type) {
        case IMAGE_TYPES.RESIDENTIAL:
          setErrorUploadDocumentResidential(false);
          await PostSendDocuments.callApi({
            base64: image.split(",")[1],
            tipo: IMAGE_TYPES.RESIDENTIAL,
          });
          setDocumentsPicture1(image);
          break;
        case IMAGE_TYPES.INCOME:
          setErrorUploadDocumentIncome(false);
          const responseDocuments = await PostSendDocuments.callApi({
            base64: image.split(",")[1],
            tipo: IMAGE_TYPES.INCOME,
          });
          if (responseDocuments.status === 200) {
            setDialogOpen(true);
          } else {
            setErrorPopUpUpload(false);
            setDialogOpen(true);
          }
          setDocumentsPicture2(image);
          break;
        default:
          return;
      }
    } catch (error) {
      switch (type) {
        case IMAGE_TYPES.RESIDENTIAL:
          setErrorUploadDocumentResidential(true);
          break;
        case IMAGE_TYPES.INCOME:
          setErrorUploadDocumentIncome(true);
          break;
        default:
          return;
      }
      setErrorPopUpUpload(true);
    } finally {
      setImageIsLoading(null);
    }
  };


  const handleReUploadPicture = async () => {
    setErrorPopUpUpload(false);

    switch (lastPictureUploaded) {
      case IMAGE_TYPES.RESIDENTIAL:
        await handleReUploadPicture(auxImage, IMAGE_TYPES.RESIDENTIAL);
        break;
      case IMAGE_TYPES.INCOME:
        await handleReUploadPicture(auxImage, IMAGE_TYPES.INCOME);
        break;
      default:
        return;
    }
  };

  const onTakeDocumentPicture = async (imageBase64, index) => {
    if (index === 1) {
      setLastPictureUploaded(IMAGE_TYPES.RESIDENTIAL);
      await handleUploadPicture(imageBase64, IMAGE_TYPES.RESIDENTIAL);
    } else {
      setLastPictureUploaded(IMAGE_TYPES.INCOME);
      await handleUploadPicture(imageBase64, IMAGE_TYPES.INCOME);
    }
  };

  const goToHome = () => {
    history.push("/loan-home")
  }

  return (
    <>
    <TwoButtonPopup
        bodyText="Erro ao fazer upload dos documentos!"
        leftButtonText="Cancelar"
        rightButtonText="Tentar novamente"
        visibility={errorPopUpUpload}
        setVisibility={(val) => setErrorPopUpUpload(val)}
        confirm={handleReUploadPicture}
      />
        <OneButtonPopup
          text={"Documentos enviados com sucesso, acompanhe na tua área de empréstimos!"}
          buttonText="Voltar para a página inicial"
          visibility={dialogOpen}
          onClick={() => history.push("/loan-home")}
          setVisibility={setDialogOpen}
          slug="/loan-home"
        />
        {PostSendDocuments.loading ? (<St.WrapperLoader>
              <Loader size="large" />
            </St.WrapperLoader>) : (
        <St.Container>
          <St.Picture>
            <St.WrapperCamera show={cam1DocumentsIsOpen}>
              <Camera
                open={cam1DocumentsIsOpen}
                onTakePhoto={(img) => onTakeDocumentPicture(img, 1)}
                handleClose={() => setCam1DocumentsIsOpen(false)}
                maskDocumentIncomeAddress
              />
            </St.WrapperCamera>
          </St.Picture>
          <St.Picture>
            <St.WrapperCamera show={cam2DocumentsIsOpen}>
              <Camera
                open={cam2DocumentsIsOpen}
                onTakePhoto={(img) => onTakeDocumentPicture(img, 2)}
                handleClose={() => setCam2DocumentsIsOpen(false)}
                maskDocumentIncomeAddress
              />
            </St.WrapperCamera>
          </St.Picture>
          <St.TopSpace>
            <St.Title>Foto dos documentos</St.Title>
            <St.Subtitle>
              Precisamos que você tire uma foto de alguns documentos . Isso
              aumenta tuas chances para aprovar as ofertas de empréstimo.{" "}
            </St.Subtitle>
          </St.TopSpace>
          <St.BoxCenter>
            <St.Title
              style={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              {!documentsPicture1
                ? "Prepare o teu comprovante de endereço"
                : "Prepare o teu comprovante de renda"}
            </St.Title>
            <img src={themes.components.images.selfieLending} alt="foto documento" />
          </St.BoxCenter>
          <St.BoxDescription>
            <div>
              <img src={themes.components.images.checkOrange} alt="check" />
              <span>Escolha um local bem iluminado.</span>
            </div>
            <div>
              <img src={themes.components.images.checkOrange} alt="check" />
              <span>Posicione-se no local indicado pela câmara.</span>
            </div>
            <div>
              <img src={themes.components.images.checkOrange} alt="check" />
              <span>Gire a camera na diagonal, se for preciso. </span>
            </div>
          </St.BoxDescription>
          <St.Footer>
            <Button
              buttonType="primary"
              text="Tirar foto"
              onClick={() =>
                !documentsPicture1
                  ? toggleCameraDocuments(1)
                  : toggleCameraDocuments(2)
              }
            >
              Tirar foto
              {imageIsLoading === IMAGE_TYPES.RESIDENTIAL ||
                (imageIsLoading === IMAGE_TYPES.INCOME && (
                  <Spinner color="#fff" />
                ))}
            </Button>
          </St.Footer>
          <OneButtonPopup
          text={success}
          buttonText="Voltar para a página inicial"
          title={"Documento enviado com sucesso"}
          visibility={dialogOpen}
          iconModal={themes.components.images.successValidation}
          defaultButton
          setVisibility={setDialogOpen}
          onClose={goToHome}
          onClick={goToHome}
          slug="/loan-home"
        />
        </St.Container>
        )}
        </>
  );
};

export default SubmitDocuments;

